import { render } from "./ShippingBulkImport.vue?vue&type=template&id=3f109638&scoped=true"
import script from "./ShippingBulkImport.vue?vue&type=script&lang=js"
export * from "./ShippingBulkImport.vue?vue&type=script&lang=js"

import "./ShippingBulkImport.vue?vue&type=style&index=0&id=3f109638&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f109638"]])

export default __exports__